/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_Common_VestingTrancheViewResult } from '../models/Wealthlane_AwardService_Dtos_Common_VestingTrancheViewResult';
import type { Wealthlane_AwardService_Dtos_Response_ResponseDto } from '../models/Wealthlane_AwardService_Dtos_Response_ResponseDto';
import type { Wealthlane_AwardService_Dtos_TerminationDto_AdjustAwardLevel } from '../models/Wealthlane_AwardService_Dtos_TerminationDto_AdjustAwardLevel';
import type { Wealthlane_AwardService_Dtos_TerminationDto_AdjustAwardRequestDto } from '../models/Wealthlane_AwardService_Dtos_TerminationDto_AdjustAwardRequestDto';
import type { Wealthlane_AwardService_Dtos_TerminationDto_AdjustAwardResponseDto } from '../models/Wealthlane_AwardService_Dtos_TerminationDto_AdjustAwardResponseDto';
import type { Wealthlane_AwardService_Dtos_TerminationDto_AwardDetailForTermination } from '../models/Wealthlane_AwardService_Dtos_TerminationDto_AwardDetailForTermination';
import type { Wealthlane_AwardService_Dtos_TerminationDto_TerminationRequestDto } from '../models/Wealthlane_AwardService_Dtos_TerminationDto_TerminationRequestDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TerminationService {

    /**
     * @param requestBody
     * @returns Wealthlane_AwardService_Dtos_TerminationDto_AdjustAwardResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppTerminationAdjustAwards(
        requestBody?: Wealthlane_AwardService_Dtos_TerminationDto_AdjustAwardRequestDto,
    ): CancelablePromise<Array<Wealthlane_AwardService_Dtos_TerminationDto_AdjustAwardResponseDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/termination/adjust-awards',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_AwardService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppTerminationTerminateParticipant(
        requestBody?: Wealthlane_AwardService_Dtos_TerminationDto_TerminationRequestDto,
    ): CancelablePromise<Wealthlane_AwardService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/termination/terminate-participant',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_AwardService_Dtos_Common_VestingTrancheViewResult OK
     * @throws ApiError
     */
    public static postApiAwardApiAppTerminationTerminationPreviewByAward(
        requestBody?: Wealthlane_AwardService_Dtos_TerminationDto_AwardDetailForTermination,
    ): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Common_VestingTrancheViewResult>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/termination/termination-preview-by-award',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_AwardService_Dtos_TerminationDto_AdjustAwardResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppTerminationApplyMasterRule(
        requestBody?: Wealthlane_AwardService_Dtos_TerminationDto_AdjustAwardRequestDto,
    ): CancelablePromise<Array<Wealthlane_AwardService_Dtos_TerminationDto_AdjustAwardResponseDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/termination/apply-master-rule',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Wealthlane_AwardService_Dtos_TerminationDto_AdjustAwardResponseDto OK
     * @throws ApiError
     */
    public static postApiAwardApiAppTerminationAdjustAwardByAwardDetail(
        requestBody?: Wealthlane_AwardService_Dtos_TerminationDto_AdjustAwardLevel,
    ): CancelablePromise<Array<Wealthlane_AwardService_Dtos_TerminationDto_AdjustAwardResponseDto>> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/termination/adjust-award-by-award-detail',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
